import { type FC, Fragment } from 'react';

import { Skeleton } from '../../../components/reusable/skeleton';

const SECTION_LAYOUT: { items: number }[] = [{ items: 1 }, { items: 2 }, { items: 3 }, { items: 1 }];

export const SidebarMenuSkeleton: FC = () => (
	<ul
		className='m-0 p-0'
		aria-hidden='true'
	>
		{SECTION_LAYOUT.map((section, sectionIndex) => (
			<Fragment key={sectionIndex}>
				<li className='menu-section'>
					<Skeleton
						width={84}
						height={10}
						variant='text'
					/>
				</li>
				{Array.from({ length: section.items }).map((_, itemIndex) => (
					<li
						key={`${sectionIndex}-${itemIndex}`}
						className='sidebar-menu-skeleton-row'
					>
						<div className='menu-header'>
							<div className='svg-container'>
								<Skeleton
									width={18}
									height={18}
									variant='rounded'
								/>
							</div>
							<Skeleton
								width={`${60 + ((itemIndex * 13) % 30)}%`}
								height={12}
								variant='text'
							/>
						</div>
					</li>
				))}
			</Fragment>
		))}
	</ul>
);
